"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomTeeTimeIntervals = void 0;
const getMinutesBetweenTimes_1 = require("../getMinutesBetweenTimes");
const getCustomTeeTimeIntervals = (start_time, end_time, custom_interval) => {
    // round start_time to the nearest 5 minutes
    const start = new Date(`01/01/2020 ${start_time}`);
    const start_minutes = start.getMinutes();
    const start_minutes_rounded = Math.round(start_minutes / custom_interval) * custom_interval;
    const start_time_rounded = new Date(start.setMinutes(start_minutes_rounded));
    // round end_time to the nearest 5 minutes
    const end = new Date(`01/01/2020 ${end_time}`);
    const end_minutes = end.getMinutes();
    const end_minutes_rounded = Math.round(end_minutes / custom_interval) * custom_interval;
    const end_time_rounded = new Date(end.setMinutes(end_minutes_rounded));
    const diff = end_time_rounded.getTime() - start_time_rounded.getTime();
    const minutes = diff / 1000 / 60;
    const intervals = [];
    for (let i = 0; i < minutes / custom_interval; i++) {
        const slot_start = new Date(start_time_rounded.getTime() + i * custom_interval * 60 * 1000);
        const slot_end = new Date(start_time_rounded.getTime() + (i + 1) * custom_interval * 60 * 1000);
        intervals.push({
            start_time: slot_start.toTimeString().slice(0, 5),
            diff: custom_interval,
            end_time: slot_end.toTimeString().slice(0, 5),
        });
    }
    if (start_time < intervals[0].start_time) {
        intervals.unshift({
            start_time,
            diff: (0, getMinutesBetweenTimes_1.getMinutesBetweenTimes)(start_time, intervals[0].start_time),
            end_time: intervals[0].start_time,
        });
    }
    // if the last interval end_time is greater than the end_time, then set the last interval end_time to the end_time
    if (intervals[intervals.length - 1].end_time > end_time) {
        intervals[intervals.length - 1].end_time = end_time;
        intervals[intervals.length - 1].diff = (0, getMinutesBetweenTimes_1.getMinutesBetweenTimes)(intervals[intervals.length - 1].start_time, end_time);
    }
    return intervals;
};
exports.getCustomTeeTimeIntervals = getCustomTeeTimeIntervals;
